import React from 'react';
import { ButtonV2 } from '@arc-ui/components';
import { EeIconSearch } from '@arc-ui/icons';

interface SearchTriggerProps {
  onClick: () => void;
  ariaLabel?: string;
  disabled?: boolean;
}

const SearchTrigger: React.FC<SearchTriggerProps> = ({
  onClick,
  ariaLabel = 'Open search',
  disabled = false,
}) => (
  <ButtonV2
    buttonStyle="compact"
    onClick={disabled ? undefined : onClick}
    ariaLabel={ariaLabel}
    icon={EeIconSearch}
  />
);

export { SearchTrigger };
export default SearchTrigger;
